export const money = (value: number) => {
  const amount = Number(value || 0);
  const hasKopecks = Math.abs(amount - Math.round(amount)) > 0.0001;
  return `${amount.toLocaleString('ru-RU', {
    minimumFractionDigits: hasKopecks ? 2 : 0,
    maximumFractionDigits: 2
  })} ₽`;
};
export const number = (value: number) => Number(value || 0).toLocaleString('ru-RU');
export const date = (value: string) => new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit', month: 'short', year: 'numeric'
}).format(new Date(value));
export const shortDate = (value: string) => new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit'
}).format(new Date(value));
